export const routesLinks = {
  home: "/",
  homev1: "/sconv-1",
  homev2: "/sconv-2",
  aboutus: "/about-us",
  careers: "/careers",
  privacypolicy: "/privacy-policy",
  termsandconditions: "/terms-and-conditions",
  demoform: "/demo",
  aiReadiness: "/test-ai-readiness",
  schoolpartner: "/school-partner",
  demorun: "/demorun",
  demoprofiles: "/demoprofiles",
  teachersDay2026: "/teachers-day2026",
  teachersDay2026Parents: "/teachers-day2026-parents",
};

export const Blog_URL = `https://coschool.medium.com/`;

export const ResourceHub_URL = `https://www.coschool.ai/resource-hub/`;

export const trackButtonClick = (buttonLabel) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'homepage_cta_click', {
      'cta_button': buttonLabel
    });
  }
};

export const trackSelectedActions = (selectedAction, sourceButton) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'homepage_intent', {
      'selected_option': selectedAction,
      'source_cta': sourceButton
    });
  }
};

export const trackScrollDepth = (percentage, page = 'homepage') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'scroll_depth', {
      'scroll_percentage': percentage,
      'page_name': page,
      'page_location': window.location.pathname
    });
  }
};

export const trackSchoolEnquiryConversion = (enquiryData) => {
  if (typeof window !== 'undefined' && window?.gtag) {
    const nameParts = (enquiryData?.name || '').trim().split(/\s+/);
    const firstName = nameParts[0] || '';
    const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';

    const userData = {
      'email': [enquiryData?.email],
      'phone_number': ['+91' + enquiryData?.phoneNumber],
      'address': [
        {
          'first_name': firstName,
          'last_name': lastName,
          'city': enquiryData?.city,
          'country': 'IN',
          'school_name': enquiryData?.schoolName,
          'designation': enquiryData?.designation,
          'challenges': enquiryData?.challenges,
          ...(enquiryData?.designation === 'Other' && { 'other_designation': enquiryData?.otherDesignation })
        }
      ]
    };

    window.gtag('set', 'user_data', userData);
  }
};



